import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../layouts/Blogsidebar';
// import Pagination from '../../layouts/Pagination';
// import Time from '../../pages/Time';

// import img1 from '../../../assets/img/blog/1.jpg';
// import img2 from '../../../assets/img/blog/2.jpg';
// import img3 from '../../../assets/img/blog/3.jpg';
import img4 from '../../../assets/img/blog/03.jpg';



class Content extends Component {
    state = {
        blogposts: []
    }

    formatDate(date) {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const d = new Date(date);
        const month = months[d.getMonth()];
        const day = d.getDate();
        const year = d.getFullYear();

        return `${year} ${month} ${day}`;
    }

    async componentDidMount() {
        const response = await fetch("https://petsgo.zimworx.site/wp-json/custom/v1/jw-blogs");
        const data = await response.json();
        this.setState({
            blogposts: data
        })
        console.log(data)
    }

    render() {
        return (
            <section className="blog-section section-gap-top">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {/* Blog loop(Grid) */}
                            <div className="blog-loop grid-blog row justify-content-center">
                                {/* Single Post */}

                                {
                                    this.state.blogposts.map((item, i) => (
                                        <div key={i} className="col-lg-6 col-md-6 col-10 col-tiny-12">
                                            <Link to={`/blog/${item.slug}`}>
                                                <div className="single-post-box">
                                                    <div className="post-thumb">
                                                        <Link to={`/blog/${item.slug}`}>
                                                            <img src={item.featured_img_src ? item.featured_img_src : img4} alt="" />
                                                        </Link>
                                                    </div>
                                                    <div className="post-content">
                                                        <span className="post-date"><i className="far fa-calendar-alt" />{this.formatDate(item.date_published)}</span>
                                                        <h3 className="title">
                                                            <Link to={`/blog/${item.slug}`}>{item.title}</Link>
                                                        </h3>
                                                        {/* <p style={{ color: '#616161' }} >{`${item.description.substring(0, 100)}...`}</p> */}

                                                        <p style={{ color: '#616161' }} >{item.description.substring(0, 100).replace(/<[^>]*>/g, '')}...</p>

                                                        <Link to={`/blog/${item.slug}`} className="post-link">
                                                            Read more<i className="far fa-long-arrow-right" />
                                                        </Link>

                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                }
                                {/* {blogblock.map((item, i) => (
                                    <div key={i} className="col-lg-6 col-md-6 col-10 col-tiny-12">
                                        <div className="single-post-box">
                                            <div className="post-thumb">
                                                <img src={item.img} alt="" />
                                            </div>
                                            <div className="post-content">
                                                <span className="post-date"><i className="far fa-calendar-alt" />{item.postdate}</span>
                                                <h3 className="title">
                                                    <Link to="/blog">{item.title}</Link>
                                                </h3>
                                                <p>{item.text}</p>
                                                <Link to="/blog" className="post-link">
                                                    {item.urltext} <i className="far fa-long-arrow-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))} */}
                            </div>
                            {/* Pagination */}
                            {/* <Pagination /> */}
                        </div>
                        <div className="col-lg-4 col-md-8">
                            {/* sidebar */}
                            <Sidebar />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Content;